// extracted by mini-css-extract-plugin
export default {"container":"dFPULeH50zw0XEw75BW0","cardList":"Zfi_FsTTh3cb_BfBpbbo","continue":"mdzFF3JmsfR4929ZGLIf","linkButton":"TVB_rA7xxZtqvFmh5nMm","modalBody":"jZmluBphCKEL5fbdoYUU"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"dFPULeH50zw0XEw75BW0\",\"cardList\":\"Zfi_FsTTh3cb_BfBpbbo\",\"continue\":\"mdzFF3JmsfR4929ZGLIf\",\"linkButton\":\"TVB_rA7xxZtqvFmh5nMm\",\"modalBody\":\"jZmluBphCKEL5fbdoYUU\"}";
        // 1752251487113
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  